"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.COMPONENT_NAME = void 0;
var _classNameGenerator = require("../../theming/classNameGenerator");
var COMPONENT_NAME = exports.COMPONENT_NAME = 'ModalDialog';
var CLASSNAME_MODAL_DIALOG = (0, _classNameGenerator.generateComponentClassNames)({
  component: COMPONENT_NAME,
  children: ['Header', 'Title', 'Content', 'Icon', {
    component: 'Icon',
    children: ['Wrapper']
  }, 'Actions']
});
var _default = exports["default"] = CLASSNAME_MODAL_DIALOG;